import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  blLanguage: number = 0;
}
